import React, { FC } from 'react';

import classes from 'classnames';
import { prop } from 'ramda';
//@ts-ignore
import { components } from 'react-select';

import BaseReactSelect from 'components/shared/FormAdapters/FormBase/ReactSelect/SimpleValueAdapter';
import Icon from 'components/shared/Icon';
import Left from 'components/shared/Icon/icons/Left';

import styles from './index.module.css';
import { IReactSelectProps } from './types';

export const DropdownIndicator = (dropProps: any) => {
  return (
    <components.DropdownIndicator {...dropProps}>
      <Icon component={Left} stroke="#3F3C43" width="16px" height="16px" strokeWidth={3} className={styles.dropIcon} />
    </components.DropdownIndicator>
  );
};

const ReactSelect: FC<IReactSelectProps> = ({
  size,
  className,
  isError,
  customComponents,
  theme,
  readOnly,
  withBackground,
  ...props
}) => {
  const reactSelectClasses = classes(
    styles.reactSelectContainer,
    size && prop(`reactSelectContainer-${size}`, styles),
    theme && prop(`reactSelectContainer-${theme}`, styles),
    isError && prop('reactSelectContainer-isError', styles),
    readOnly && prop('reactSelectContainer-readOnly', styles),
    withBackground && prop('reactSelectContainer-withBackground', styles),
    className,
    'custom-input-select-container',
    isError && 'custom-input-select-container-isError',
    readOnly && 'custom-input-select-container-readOnly',
  );

  return (
    <div className={reactSelectClasses}>
      <BaseReactSelect
        {...props}
        tabIndex={readOnly ? -1 : readOnly}
        components={{ DropdownIndicator, ...customComponents }}
      />
    </div>
  );
};

export default ReactSelect;
